/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextArticleTIcon24Solid = forwardRef('TextArticleTIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M1 3.5A1.5 1.5 0 0 1 2.5 2h6a1.5 1.5 0 1 1 0 3H7v4.75a1.5 1.5 0 0 1-3 0V5H2.5A1.5 1.5 0 0 1 1 3.5Z" }),
        React.createElement("path", { d: "M13.5 3a1.5 1.5 0 0 0 0 3h7a1.5 1.5 0 0 0 0-3h-7Z" }),
        React.createElement("path", { d: "M13.5 8a1.5 1.5 0 0 0 0 3h7a1.5 1.5 0 0 0 0-3h-7Z" }),
        React.createElement("path", { d: "M3.5 18a1.5 1.5 0 0 0 0 3h17a1.5 1.5 0 0 0 0-3h-17Z" }),
        React.createElement("path", { d: "M2 14.5A1.5 1.5 0 0 1 3.5 13h17a1.5 1.5 0 0 1 0 3h-17A1.5 1.5 0 0 1 2 14.5Z" })));
});
